import Vue from "vue";
import moment from "moment";

Vue.use({
  install(Vue, options) {
    Vue.mixin({
      computed: {
        meta() {
          const meta = this.$route.matched.reduce(
            (obj, m) => {
              return { ...obj, ...m.meta };
            },
            { hideSidebar: true, hideHeader: false }
          );
          return meta;
        },
        user() {
          return this.$store.getters.user;
        },
        pid() {
          return this.$route.query.pid || undefined;
        },
        isPrivate() {
          return this.pid.startsWith("PRIVATE_");
        },
        gid() {
          return +this.$route.query.gid || undefined;
        },
        nid() {
          return this.$route.params.id || undefined;
        },
        draw() {
          return this.$store.getters.draw || null;
        },
      },
      methods: {
        async fileUpload(file, key = "file", auth = true) {
          const formData = new FormData();
          formData.append(key, file);
          
          let data;
          // @ts-ignore: Unreachable code error
          if( auth ) data = await this.$wApi.file.post(formData);
          // @ts-ignore: Unreachable code error
          else data = await this.$wApi.file.upload(formData);
          
          if (!data) return;
          return data;
        },
        insertEvent(editor, insertPosition, type, target) {
          const window = {
            type: "w-window",
            attrs: insertPosition as { top: number; left: number },
            content: [
              {
                type: "paragraph",
                text: "",
              },
            ],
          };
          editor.isActive("w-window")
            ? editor.chain().focus()[type](target).run()
            : editor
                .chain()
                .focus()
                .insertContentAt(1, window)
                [type](target)
                .run();
        },
        // async fileDelete(key) {
        //   // @ts-ignore: Unreachable code error
        //   const data = await this.$wApi.files.delete(null, key);
        //   if (!data) return;
        //   return data;
        // },

        getDate(date, format = "YYYY.MM.DD") {
          return moment(date).format(format);
        },
      },
    });
  },
});
